import Vue from 'vue'
// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
// Dashboard pages
import DashboardLayout from 'src/pages/dashboard/.Layout/DashboardLayout.vue'
import HomeTop from 'src/pages/dashboard/home/HomeTop.vue'
// Payouts page
import PaymentCard from 'src/pages/dashboard/PaymentCard.vue'
// Invoices page
import Invoices from 'src/pages/dashboard/Invoices.vue'
// Pages
import Login from 'src/pages/Login.vue'
import ChangePassword from 'src/pages/ChangePassword.vue'
import Register from 'src/pages/Register.vue'
import Lock from 'src/pages/Lock.vue'
import Invitation from 'src/pages/Invitation.vue'
import Version from 'src/pages/Version.vue'
// Setup
import Setup from 'src/pages/dashboard/Setup.vue'

// other
import store from '@/store/store'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/changePassword',
      name: 'Change Password',
      meta: { requiresAuth: true },
      component: ChangePassword
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: Invitation
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '/dashboard',
      meta: { requiresAuth: true },
      component: DashboardLayout,
      redirect: '/dashboard/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: HomeTop,
          async beforeEnter (to, from, next) {
            await store.dispatch('fetchBaseData')
            if (store.getters.userStatus == 'active') {
              await store.dispatch('fetchData', { period: 'this month+', scope: 'home' })
            }
            next()
          }
        },
        {
          path: 'paymentCard',
          name: 'Payment Card',
          component: PaymentCard
        },
        {
          path: 'setup',
          name: 'Setup',
          component: Setup,
          async beforeEnter (to, from, next) {
            await store.dispatch('fetchBaseData')
            next()
          }
        }
      ],
    },
    {
      path: '/404',
      name: '404',
      props: true,
      component: NotFound
    },
    {
      path: '*/v(ersion)?',
      name: 'App Version',
      meta: { requiresAuth: true },
      component: Version
    },
    {
      path: '*',
      redirect: {name: '404', params: {resourceType: 'page'}}
    }
  ]
})




// we check session validity before entering any secure page
router.beforeEach (async (to, from, next) => {
  console.log('beforeEach(): route requested = ', to.fullPath.toString())
  NProgress.start()
  NProgress.set(0.4)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // For protected routes, we make sure there is a token in local storage
    const session = JSON.parse(localStorage.getItem('userSession') || '{}')
    console.log('session from local storage: ', session)
    if (!!session && !!session.token) {
      console.log('1')
      try { // we make sure the token is still valid
        console.log('1.1')
        await store.dispatch('setToken', session.token)
        const isTokenValid = await store.dispatch('isSessionValid')
        if (isTokenValid) {
          console.log('> router.beforeEach(): token valid')
          next()
        }
        else {
          console.log('> router.beforeEach(): token invalid')
          store.commit('CLEAR_SESSION')
          NProgress.done()
          next('/login')
        }
        
      }
      catch (error) { // we redirect to login if there was an issue
        store.commit('CLEAR_SESSION')
        NProgress.done()
        next('/login')
      }
    }
    else {
      console.log('2')
      // if (from.fullPath == to.fullPath) {
        NProgress.done()
      // }
      next('/login')
    }
  }
  else { // Unprotected routes
    console.log('3')
    next()
  }
})

router.afterEach (() => {
  NProgress.done()
})

export default router
